import Barba from 'barba.js';
import Utils from '../utils/utils.js';
import ReminderModal from '../components/reminderModal.js';

export default Barba.BaseView.extend( {
	namespace: 'event',
	
	onEnter() {
		const self = this;

		// The new Container is ready and attached to the DOM.
		this.$eventContainer = jQuery( this.container ).find( '.c-event-single' );
		this.is_ajax = this.$eventContainer.hasClass( 'c-event-single--init-ajax' );

		this.reminderModal = new ReminderModal( {
			container: this.container
		} );

		if ( ! this.is_ajax && ! Utils.isMobile() ){
			jQuery( window ).one( 'load.oax::event-page', jQuery.proxy( this.scrollToEventTop, this ) );
		}

		if ( this.is_ajax ){
			// this.setContainerFix();
		}

		if ( jQuery( this.container ).find( '.gallery' ).length > 0 ){
			const $galleries = jQuery( this.container ).find( '.gallery' );
			$galleries.each( ( i, el ) => {
				const $el = jQuery( el );
				$el.find( 'a' ).attr( 'target', '_blank' );
			} );
		}

		const lazyFixHeaderInformation = Utils.debounce( jQuery.proxy(this.fixHeaderInformation, this), 250 ); // eslint-disable-line
		setTimeout( () => {
			self.fixHeaderInformation();	
		}, 400 );
		jQuery( window ).on( 'resize.oax::event-page:fixheader', lazyFixHeaderInformation );
	},
	
	onEnterCompleted() {
		if ( this.is_ajax ){
			this.scrollToEventTop();			
		}
		// The Transition has just finished.
	},
	
	onLeave() {
		// A new Transition toward a new page has just started.
		this.reminderModal.destroy();
	},
	
	onLeaveCompleted() {
		// The Container has just been removed from the DOM.
	},

	fixHeaderInformation(){
		const $parentContainer = jQuery( this.container ).find( '.c-event-single__aside-body' ),
			$detailContainer = jQuery( this.container ).find( '.c-event-single__aside ul' );

		// console.log( Utils.isMobile() );

		if ( Utils.isMobile() ){
			const widthContentInfoContainer = jQuery( this.container ).find( '.c-event-single__aside ul li:nth-child(1)' ).outerWidth( true ) + jQuery( this.container ).find( '.c-event-single__aside ul li:nth-child(3)' ).outerWidth( true ),
				widthContentLinksContainer = jQuery( this.container ).find( '.c-event-single__aside ul li:nth-child(2)' ).outerWidth( true ) + jQuery( this.container ).find( '.c-event-single__aside ul li:nth-child(5)' ).outerWidth( true ),
				widthParentContainer = jQuery( this.container ).find( '.c-event-single__aside-body' ).width(),
				isBigger = widthContentLinksContainer > widthParentContainer || widthContentInfoContainer > widthParentContainer; // eslint-disable-line
			
			// console.log( isBigger );

			if ( isBigger ){ 
				$parentContainer.addClass( 'is-overflow' );
				$parentContainer.css( 'overflow-x', 'scroll' );
				$detailContainer.width( ( widthContentLinksContainer > widthContentInfoContainer ? widthContentLinksContainer : widthContentInfoContainer ) + 20 ); // eslint-disable-line
			}
		} else {
			$detailContainer.removeAttr( 'style' );
			$parentContainer.removeAttr( 'style' );
			$parentContainer.removeClass( 'is-overflow' );
		}
	},

	setContainerFix(){
		jQuery( this.container ).children().wrapAll( '<div class="site__scroll-inner"></div>' );
		jQuery( this.container ).addClass( 'scrolling-touch' );		
		gsap.set( this.container, {
			position: 'fixed',
			overflow: 'scroll',
			height: '100vh',
			width: '100vw',
			zIndex: 99999,
			left: 0,
			top: jQuery( 'body' ).hasClass( 'admin-bar' ) ? 32 : 0,			
		} );
	},

	scrollToEventTop( event ){
		const scrollTop = jQuery( 'header' ).height() + parseInt( jQuery( '.c-event-single' ).css( 'margin-top' ), 10 ) + 1;
		let _animate = event === true ? true : false; // eslint-disable-line
		
		if ( _animate ){
			console.log( 'animate shit' );
		} else {
			setTimeout( () => {
				window.scrollTo( 0, scrollTop );	
			}, 1 );
		}
	}
} );
